export const CommonBoards10th = [
    { value: 'CBSE (Central Board of Secondary Education)', label: 'CBSE (Central Board of Secondary Education)' },
    { value: 'ICSE (Indian Certificate of Secondary Education)', label: 'ICSE (Indian Certificate of Secondary Education)' },
    { value: 'State Board', label: 'State Board' },
    { value: 'NIOS (National Institute of Open Schooling)', label: 'NIOS (National Institute of Open Schooling)' },
    { value: 'IB (International Baccalaureate)', label: 'IB (International Baccalaureate)' },
    { value: 'IGCSE (Cambridge International)', label: 'IGCSE (Cambridge International)' },
    { value: 'Maharashtra State Board', label: 'Maharashtra State Board' },
    { value: 'UP State Board', label: 'UP State Board' },
    { value: 'West Bengal Board of Secondary Education (WBBSE)', label: 'West Bengal Board of Secondary Education (WBBSE)' },
    { value: 'Other', label: 'Other' },
];

export const CommonBoards12th = [
    { value: 'CBSE (Central Board of Secondary Education)', label: 'CBSE (Central Board of Secondary Education)' },
    { value: 'ISC (Indian School Certificate)', label: 'ISC (Indian School Certificate)' },
    { value: 'State Board', label: 'State Board' },
    { value: 'NIOS (National Institute of Open Schooling)', label: 'NIOS (National Institute of Open Schooling)' },
    { value: 'IB (International Baccalaureate)', label: 'IB (International Baccalaureate)' },
    { value: 'IGCSE (Cambridge International)', label: 'IGCSE (Cambridge International)' },
    { value: 'Maharashtra State Board', label: 'Maharashtra State Board' },
    { value: 'UP State Board', label: 'UP State Board' },
    { value: 'West Bengal Council of Higher Secondary Education (WBCHSE)', label: 'West Bengal Council of Higher Secondary Education (WBCHSE)' },
    { value: 'Other', label: 'Other' },
];
